export default __webpack_public_path__ + "static/media/q_wdt_c_3.1d0bcdf4.mp3";